import { Pagination, PaginationProps } from "@heroui/react";
import { LimeSelect } from "./LimeSelect";
import { cn } from "@/utils";
import { useMemo, useRef } from "react";

export const LimePagination = ({
  paginationProps,
  perPageProps,
  className,
}: {
  paginationProps: Omit<PaginationProps, "total"> & { total?: number };
  perPageProps: {
    label: string;
    onChange?: (value: string) => void;
    value?: string;
    values?: number[];
  };
  className?: string;
}) => {
  const previousKnownPageCount = useRef(1);
  const pageCount = useMemo(() => {
    if (paginationProps.total == null) {
      return previousKnownPageCount.current;
    }

    previousKnownPageCount.current = paginationProps.total;
    return paginationProps.total;
  }, [paginationProps.total]);

  const isDisabled = paginationProps.isDisabled || pageCount === 0;

  return (
    <div
      className={cn(
        "flex w-full flex-col-reverse justify-between gap-2 md:flex-row",
        className,
      )}
    >
      <Pagination
        {...paginationProps}
        total={pageCount}
        className={cn("max-w-full", paginationProps.className)}
        showControls
        isDisabled={isDisabled}
      />
      {perPageProps.values && perPageProps.values.length > 1 && (
        <LimeSelect
          {...perPageProps}
          label={undefined}
          isDisabled={isDisabled}
          className="max-w-full md:max-w-44"
          items={perPageProps.values.map((value) => ({
            label: `${value} ${perPageProps.label}`,
            key: String(value),
          }))}
        />
      )}
    </div>
  );
};
